module.exports = __webpack_public_path__ + "static/media/adjuge-it.6cfb9adc.png";